import {
  doc,
  onSnapshot,
  FirestoreError,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../../../firebase";
import {
  EntityGet,
  EntityServerGet,
  OnSnapshotDocService,
} from "../../../types";
import { Step } from "./types";
import { transformMetadata, processTimestampFields } from "../../../utils";

export type StepOnSnapshotDocService<T> = (
  playbookId: string,
  versionId: string,
  id: string,
  callback: (doc: T) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotDoc: StepOnSnapshotDocService<EntityGet<Step>> = (
  playbookId,
  versionId,
  id,
  callback,
  onError
) => {
  const docRef = doc(
    db,
    `/playbook/${playbookId}/version/${versionId}/step/${id}`
  );
  return onSnapshot(
    docRef,
    (docSnap) => {
      if (docSnap.exists()) {
        callback(
          processTimestampFields(
            transformMetadata(
              {
                ...docSnap.data(),
                id: docSnap.id,
              } as EntityServerGet<Step>,
              docSnap.metadata
            )
          ) as EntityGet<Step>
        );
      }
    },
    onError
  );
};

export default onSnapshotDoc;
